import React from "react";
import { BaseDrawer } from "./base";

interface EnseigneDrawerProps {
  enseigne: any;
  onClose: () => void;
}

export function EnseigneDrawer({ enseigne, onClose }: EnseigneDrawerProps) {
  return <BaseDrawer entity={enseigne} entityType="enseigne" onClose={onClose} />;
}
